import io from "socket.io-client/dist/socket.io.slim.dev";
import { Socket } from '@flic-chat/js-sdk';

// TODO: find a way to properly package this URL
const socket = new Socket(io, process.env.PREACT_APP_REALTIME_URL);

export default socket;

export { MessageTypes } from '@flic-chat/js-sdk';



// WEBPACK FOOTER //
// ./socket/index.js